function initProductDropDowns(productHandle) {
  function updateOneEyeCheck() {
    if ($('#chk-is-oneeye').prop('checked')) {
      $('.op-item-2.chk-add').prop('checked', false);
      $('.op-column>:last-child, .op-column .op-separator').fadeOut({complete:function(){
        $('.op-group-title label:first').html('One Eye');
      }});
      $('.product-options').addClass('one-eye');
    } else {
      $('.op-item-2.chk-add').prop('checked', 'checked');
      $('.op-column>:last-child, .op-column .op-separator').fadeIn();
      $('.product-options').removeClass('one-eye');
      $('.op-group-title label:first').html('Left Eye (OS)');
    }
  }
  $('#chk-is-oneeye').on('click', updateOneEyeCheck);
  updateOneEyeCheck();

  $('.product-options select').each(function(){
      //if($(this).find('option:contains("+")').length>0) {
          var select = $(this);
          var isPower = select.data('name')=='properties[_power]';
          var showNegative = false;
          var columnNegative = '<div class="head">-</div>';
          var columnPositive = isPower ? '<div class="head">+</div>' : '';
          if (isPower) {
            showNegative = true;
            $(this).find('option:contains("-")').each(function(){
                columnNegative += '<div class="item">'+ $(this).val() +'</div>';
            });
            $(this).find('option[value="0"]').each(function(){
                columnPositive += '<div class="item">'+ $(this).val() +'</div>';
            });
            $(this).find('option:contains("+")').each(function(){
                columnPositive += '<div class="item">'+ $(this).val() +'</div>';
            });
          } else {
            $(this).find('option').each(function(){
                if (this.value!='') //exclude -Select- option
                    columnPositive += '<div class="item">'+ $(this).val() +'</div>';
            });
          }
          var html = '';
          if (showNegative)
              html = '<div class="two-columns-select"><div class="flex"><div class="one-half left">'+columnNegative+'</div><div class="one-half">'+columnPositive+'</div></div></div>';
          else
              html = '<div class="two-columns-select"><div class="flex"><div class="one-whole">'+columnPositive+'</div></div></div>';
          var dropdown = $(html).insertAfter($(this));
          var simulator = $('<div class="select-simulator">Select</div>').insertAfter($(this));
          $(this).hide();

          simulator.closest('.op-field-wrapper').on('click', function(){
              if(dropdown.is(':visible')) {
                dropdown.hide();
              } else {
                $('.two-columns-select:visible').hide();
                var fsize = parseFloat(dropdown.find('.item').css('font-size'));
                if((simulator.offset().top-$(document).scrollTop()) - $('#header').height() - 30 > 144) {
                  var height = simulator.offset().top - $(document).scrollTop() - $('#header').height() - 30;
                  height = height - ((height-17-4) % (8+fsize)) + (8+fsize)/2;
                  dropdown.css({bottom: simulator.outerHeight(), top: 'auto', 'max-height': height});
                } else {
                  var height = $(window).height() - simulator.offset().top + $(document).scrollTop() - simulator.outerHeight() - 30;
                  height = Math.max(height, 144);
                  height = height - ((height-17-4) % (8+fsize)) + (8+fsize)/2;
                  dropdown.css({top: simulator.outerHeight(), bottom: 'auto', 'max-height': height});
                }
                dropdown.show();
              }
          });
          select.on('change', function(){ 
            var self = this;
            simulator.html(self.value);
            simulator.next().find('.item').removeClass('selected').each(function(ix, item) {
              if (item.innerHTML == self.value) {
                $(item).addClass('selected');
                return false;
              }
            });
          });
          dropdown.find('.item').on('click', function(e){
              e.stopPropagation();
              var item = $(this);
              item.parent().find('.selected').removeClass('selected');
              item.addClass('selected');
              setTimeout(function(){
                var value = item.html();
                select.val(value);
                select.change();
                simulator.html(value);
                dropdown.hide({duration: 100});
              }, 50);
          });
      //}
  });
  
  $(document).on('click', function(event){
    if($(event.target).closest('.two-columns-select').length==0 && !$(event.target).hasClass('two-columns-select') && !$(event.target).hasClass('select-simulator') && !(($(event.target).hasClass('op-title') || $(event.target).closest('.op-title').length>0) && $(event.target).closest('.op-field').find('.select-simulator').length>0) ) {
      $('.two-columns-select:visible').hide();
    }
  });
  
  initProductOptionsRules(productHandle);
}

function initProductOptionsRules(productHandle) {

  function findOptionDdl(optionName, itemIndex) {
    return $('[data-name="properties[_'+optionName+']"].op-item-'+itemIndex);
  }

  function DropdownHideCombinations(hiddenCombinations) {
    function processCombinations(combinations, itemIndex) {
      var optionsValuesToHide = {};
      for (var i=0; i<combinations.length; i++) {
        var combination = combinations[i];
        var matched = true;
        var combinationTail = combination[combination.length-1];
        for (var j=0; j<combination.length-1; j++) {
          var srcDdl = findOptionDdl(combination[j].name, itemIndex);
          if (srcDdl.val()!=combination[j].value) {
            matched = false;
            break;
          }
        }

        if (!optionsValuesToHide[combinationTail.name]) {
          optionsValuesToHide[combinationTail.name] = [];  
        }

        if (matched) {
          optionsValuesToHide[combinationTail.name].push(combinationTail.value);
        }
      }

      for (var opName in optionsValuesToHide) {
        var ddl = findOptionDdl(opName, itemIndex);
        showAllOptions(ddl);
        hideOptions(ddl, optionsValuesToHide[opName]);
      }

    }
    var leadingOptions = {};
    for (var i=0; i<hiddenCombinations.length; i++) {
      var combOptions = hiddenCombinations[i];
      for (var j=0; j<combOptions.length-1; j++) {
        if (!leadingOptions[combOptions[j].name]) {
          leadingOptions[combOptions[j].name] = [];
        }
        leadingOptions[combOptions[j].name].push(combOptions);
      }
    }

    for (var opName in leadingOptions) {
      var combOptions = leadingOptions[opName];
      var combinationsToProcess = [];
      for (var j=0; j<combOptions.length; j++) {
        var jtail = combOptions[j][combOptions[j].length-1];
        for (var k=0; k<hiddenCombinations.length; k++) {
          var ktail = hiddenCombinations[k][hiddenCombinations[k].length-1];
          if (jtail.name==ktail.name && combinationsToProcess.indexOf(hiddenCombinations[k])==-1 ) {
            combinationsToProcess.push(hiddenCombinations[k]);
          }
        }
      }
      for (var i = 1; i<=2; i++) {
        (function(){
        var ix = i;
        var srcDdl = findOptionDdl(opName, ix);
        var combs = combinationsToProcess;
        srcDdl.on('change', function(){processCombinations(combs, ix)});
        }())
      }

    }
  }

  function DropdownChainRule(srcOptionName, dstOptionName, action) {
    for (var i = 1; i<=2; i++) {
      (function(){
      var ix = i;
      var srcDdl = findOptionDdl(srcOptionName, ix);
      var dstDdl = findOptionDdl(dstOptionName, ix);
      srcDdl.on('change', function(){action(srcDdl[0], dstDdl[0], ix)});
      }())
    }
  }

  function showAllOptions(ddl) {
    $(ddl).closest('.op-field-wrapper').find('.two-columns-select .item').show();
  }
  function hideOptions(ddl, values) {
    var $ddl = $(ddl);
    var selectedValue = $ddl.val();
    var mustClear = false;
    $ddl.closest('.op-field-wrapper').find('.two-columns-select .item').each(function(ix,e) {
      var item = $(e);
      if (values.indexOf(item.html())>-1){
        item.hide();
        if (selectedValue==item.html()) {
          mustClear = true;
        }
      }
    });
    if (mustClear) {
      $ddl.val('').change();
      $ddl.next().html('Select');
    }
  }
  
  function setOptionDdlSingleValue(ddl, value) {
    $(ddl).closest('.op-field-wrapper').find('.two-columns-select .item').each(function(ix,e) {
      var item = $(e);
      if (item.html()==value){
        item.show();
        $(ddl).val(value).change();
      }
      else
        item.hide();
    });
  }
  function setOptionDdlValue(ddl, value) {
    $(ddl).val(value).change();
  }

  var productOps = []; //this array just stores references to rule objects
  if (productOptionsSettings['hide_combinations'].length>0) {
    productOps.push(
      new DropdownHideCombinations(productOptionsSettings['hide_combinations'])
    );
  }

  switch(productHandle) {
    //add rules per product handle
    /* DISABLED BUT LEFT AS EXAMPLE
    case 'biomedics-55-evolution':
      productOps.push(
        new DropdownChainRule('power', 'base_curve', function(srcDdl, dstDdl, itemIndex){
          if (srcDdl.value.startsWith('-'))
            setOptionDdlSingleValue(dstDdl, '8.6');
          else
            setOptionDdlSingleValue(dstDdl, '8.8');
        })
      );
      break;
      */
    case 'acuvue-oasys-1-day-for-astigmatism-30pk':
      break;
  }

}